<script setup>
import { ref, onErrorCaptured } from 'vue'
import { RouterView } from 'vue-router'
import Icon from './components/Icon.vue'

// A stale tab after a deploy can 404 on an old chunk; offer a reload instead of a blank page.
const fatal = ref('')
onErrorCaptured((err) => {
  console.error(err)
  fatal.value = /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i.test(String(err?.message))
    ? 'This page was updated. Please reload to continue.'
    : 'Something went wrong. Please reload the page.'
  return false
})
</script>

<template>
  <a href="#main" class="skip-link">Skip to content</a>
  <div v-if="fatal" class="flex min-h-dvh items-center justify-center p-6 text-center">
    <div class="card max-w-sm p-6">
      <Icon name="refresh" :size="40" class="text-primary" />
      <p class="mt-2 font-semibold">{{ fatal }}</p>
      <button class="btn-primary mt-4" type="button" @click="location.reload()">Reload</button>
    </div>
  </div>
  <RouterView v-else />
</template>
